@if (showModal) {
  <div
    class="cookie-modal-wrapper">
    @if (!disappear) {
      <div
        [@appearSlowlyAnimation]
        class="bottom-modal">
        <div [ngClass]="{ 'd-flex flex-column align-items-center' : !isMobile }"
          class="modal-body">
          <div [attr.hidden]="shrinkModal ? true : null"
            [ngClass]="{'disappear' : shrinkModal, 'appear' : !shrinkModal, 'w-50' : !isMobile}"
            class="appear">
            <p id="cookie-title">
              {{ "landing.cookieTitle" | translate }}
            </p>
            <div class="img-container"
              style="display: flex; justify-content: center;">
              <img alt="cookie" id="cookie-img"
                loading="lazy"
                src="assets\scalableVectorGraphics/cookie.svg">
              </div>
            </div>
            <div [hidden]="shrinkModal">
              <div [ngClass]="shrinkModal ? 'disappear' : 'appear'"
                class="appear">
                <div class="cookie-text">
                  {{ "landing.cookieText" | translate }}
                  <u><a id="privacy-link"
                    routerLink="welcome/privacy">
                    {{ "landing.privacy" | translate }}
                  </a></u>
                </div>
              </div>
              <br>
              </div>
              <div [ngClass]="{'w-40' : !isMobile}">
                <button (click)="onAccept()"
                  class="btn btn-primary white-outline">
                  {{ "landing.accept" | translate }}
                </button>
              </div>
              <br>
                <div class="d-flex justify-content-center"
                  id="language-selection">
                  @for (language of languages; track language) {
                    <button (click)="onChangeLang(language)"
                      [ngClass]="{ active: language === selectedLang }"
                      class="link-white px-1 text-center clear-button">
                      {{ "settings." + language | translate }}
                    </button>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
